"use client"

import { globalStore } from '@/app/stores';
import { translate } from '@/assets/utils/utils';

type IProps = {
  id: string;
  replacements?: { [key: string]: string };
}

const FormattedMessage = ({ id, replacements }: IProps) => {
  // For static export, default to English to avoid hydration mismatches
  const lang = globalStore?.lang || 'en';
  const translatedValue = translate(lang, id, replacements);

  return <>{translatedValue}</>;
};

export default FormattedMessage;
